export const PERMISSION_LABELS = {
  'user.block': 'Bloquear usuario',
  'user.unblock': 'Desbloquear usuario',
  'user.edit': 'Editar usuario',
  'user.delete': 'Eliminar usuario',
  'user.view': 'Ver usuario',
  'user.ownerView': 'Ver usuario propio',
  'user.inviteEmployee': 'Invitar empleado',
  'user.ownerEdit': 'Editar usuario propio',

  'article.create': 'Crear artículo',
  'article.view': 'Ver artículo',
  'article.edit': 'Editar artículo',
  'article.ownerEdit': 'Editar artículo propio',
  'article.delete': 'Eliminar artículo',
  'article.ownerDelete': 'Eliminar artículo propio',

  'appointment.create': 'Crear cita',
  'appointment.view': 'Ver cita',
  'appointment.edit': 'Editar cita',
  'appointment.ownerEdit': 'Editar cita propia',
  'appointment.delete': 'Eliminar cita',
  'appointment.ownerDelete': 'Eliminar cita propia',
  'appointment.ownerView': 'Ver cita propia',

  'service.create': 'Crear servicio',
  'service.view': 'Ver servicio',
  'service.edit': 'Editar servicio',
  'service.ownerView': 'Ver servicio propio',
  'service.delete': 'Eliminar servicio',
  'service.ownerDelete': 'Eliminar servicio propio',

  'category.create': 'Crear categoría',
  'category.view': 'Ver categoría',
  'category.ownerView': 'Ver categoría propia',
  'category.edit': 'Editar categoría',
  'category.delete': 'Eliminar categoría',

  'image.create': 'Subir imagen',
  'image.edit': 'Editar imagen',
  'image.ownerEdit': 'Editar imagen propia',
  'image.delete': 'Eliminar imagen',
  'image.ownerDelete': 'Eliminar imagen propia',
  'image.view': 'Ver imagen',
  'image.ownerView': 'Ver imagen propia',

  'client.create': 'Crear cliente',
  'client.edit': 'Editar cliente',
  'client.ownerEdit': 'Editar cliente propio',
  'client.delete': 'Eliminar cliente',
  'client.ownerDelete': 'Eliminar cliente propio',
  'client.view': 'Ver cliente',
  'client.ownerView': 'Ver cliente propio',

  'form.create': 'Crear formulario',
  'form.view': 'Ver formulario',
  'form.edit': 'Editar formulario',
  'form.ownerView': 'Ver formulario propio',
  'form.delete': 'Eliminar formulario',
  'form.ownerEdit': 'Editar formulario propio',
  'form.ownerDelete': 'Eliminar formulario propio',
};
